import React from "react";

import StandardModeIcon from "../standard-mode-icon";

import ModeIconRenderer from "./mode-icon-renderer";

export default {
  title: "Icons/StandardModeIcon",
  component: StandardModeIcon
};

export const StandardModeIconExamples = () => {
  return <ModeIconRenderer component={StandardModeIcon} />;
};
